module.exports = __webpack_public_path__ + "static/media/sign-in.bdb87fc5.svg";